(function () {
  'use strict';

  function paymentFactory (apiFactory, companyFactory, recipientsFactory,
    $localStorage, Common, $rootScope, odrCalendarFactory) {
    const factory = {};

    const massUnit = {
      'kilo': 'kg',
      'gram': 'g'
    };

    const recipients = {
      FILE: parseInt(Common.get('recipients.validAddressCount', 0)),
      COMPANIES: parseInt(Common.get('recipients.refinedAddressCount', 0)),
      INDIVIDUALS: parseInt(Common.get('recipients.refinedAddressCount', 0))
    };

    factory.paymentResponseCode = 'None';

    function setPaymentResponseCode (res) {
      factory.paymentResponseCode = res;
    }

    function getPaymentResponseCode () {
      return factory.paymentResponseCode;
    }

    function getPtmObjectId (ptmObject, addressType, odrService) {
      let objectId = {};
      if (ptmObject && ptmObject[addressType] !== null) {
        objectId = ptmObject[addressType];

        if (addressType === 'ODR') {
          objectId = objectId[odrService];
        }
      }

      return objectId;
    }

    function fetchProductTerms (product) {
      const addressType = Common.get('recipients.addressType');
      const ptmObject = product.termsOfServices.ptmObjectId;
      const odrService = product.pricingInfo.deliveryOptions.ODRService;
      let objectId = {};

      objectId = getPtmObjectId(ptmObject, addressType, odrService);

      if (!objectId) {
        return;
      }

      const data = {
        'userType': $rootScope.isNCPUser() ? 'company' : 'public',
        'objectId': objectId
      };
      return apiFactory.fetchProductTerms.get(data).$promise;
    }

    function getPaymentMethods (country) {
      const data = {
        'country': country
      };
      return apiFactory.getPaymentMethods.get(data).$promise;
    }

    function removeOtherDeliveryOptions (options, delivery) {
      return options.filter(function (option) {
        return option.deliveryId === delivery.deliveryId;
      })[0];
    }

    function checkInteger (val) {
      let newVal = val;
      let integer = val.split(',')[0];

      if (integer.length > 3) {
        integer = parseInt(integer) / 1000;
        newVal = integer.toFixed(3) + ',' + val.split(',')[1];

      }

      return newVal;
    }

    function addDecimalAndUnits (price, units) {
      let val = (price || 0) / 100;
      val = val.toFixed(2);
      val = val.replace('.', ',');
      val = checkInteger(val);
      val = units ? val + ' ' + units : val;

      return val;
    }

    function integrateWithSelected (resProduct) {
      const product = angular.copy(resProduct);
      const selected = angular.copy($localStorage.productDelivery);
      const materialDetails = angular.copy(Common.get('materialDetails'));

      product.deliveryDate = selected.deliveryDate;
      product.pricingInfo.deliveryOptions
        = removeOtherDeliveryOptions(product.pricingInfo.deliveryOptions, selected.pricingInfo.deliveryOptions);
      product.pricingInfo.printingInfo.basePrice.price
        = addDecimalAndUnits(product.pricingInfo.printingInfo.basePrice.price);
      product.numberOfRecipients = recipients[Common.get('recipients.targetType', 'FILE')];
      product.sendoutName = materialDetails.sendoutName;

      Common.set('productDelivery', product);

      return product;

    }

    function modifyPriceObj (priceObj) {
      let shipmentCnt = (priceObj.baseProduct || {}).count || 0;
      let additionalServicesPrice = 0;
      let totalPostage = 0;

      if (Object.keys(priceObj).length) {
        priceObj.baseProduct.price = addDecimalAndUnits(priceObj.baseProduct.price);
        priceObj.baseProduct.priceWithVAT = addDecimalAndUnits(priceObj.baseProduct.priceWithVAT);
        priceObj.total = addDecimalAndUnits(priceObj.total);
        priceObj.totalVAT = addDecimalAndUnits(priceObj.totalWithVAT);
        priceObj.VATAmount = addDecimalAndUnits(priceObj.VATAmount);
        priceObj.totalWithVAT = addDecimalAndUnits(priceObj.totalWithVAT);

        priceObj.additionalServicesDisplay = [];
        (priceObj.additionalServices || []).forEach((item) => {
          additionalServicesPrice = additionalServicesPrice + item.price;
          const rawPrice = Number(item.price);
          item.price = addDecimalAndUnits(item.price);
          item.priceWithVAT = addDecimalAndUnits(item.priceWithVAT);
          item.VAT = addDecimalAndUnits(item.VAT);

          const category = item.category || 'PAYMENTS_PAGE_OPTIONAL';
          let found = false;
          for (let i = 0; i < priceObj.additionalServicesDisplay.length; i++) {
            if (priceObj.additionalServicesDisplay[i].category === category) {
              priceObj.additionalServicesDisplay[i].items.push(item);
              priceObj.additionalServicesDisplay[i].price += rawPrice;
              found = true;
              break;
            }
          }

          if (!found) {
            priceObj.additionalServicesDisplay.push({
              category: category,
              priority: item.priority || 100, items: [item],
              price: rawPrice
            });
          }
        });

        priceObj.additionalServicesDisplay.forEach(function (category) {
          category.price = addDecimalAndUnits(category.price);
        });

        priceObj.additionalServicesDisplay.sort(function (a, b) {
          if (a.priority < b.priority) {
            return -1;
          } else if (a.priority > b.priority) {
            return 1;
          }
          return 0;
        });

        if (priceObj.postage.length) {
          shipmentCnt = 0;
        }

        priceObj.postage.forEach(function (item) {
          totalPostage = totalPostage + item.price;
          item.price = addDecimalAndUnits(item.price);
          item.priceWithVAT = addDecimalAndUnits(item.priceWithVAT);
          item.VAT = addDecimalAndUnits(item.VAT);

          if (item.pricePerSendout) {
            item.pricePerSendout = addDecimalAndUnits(item.pricePerSendout);
          }

          if (item.weight) {
            item.weight = (item.weight || '0,00') + massUnit[item.weightUnit || 'kilo'];
            item.weightPrice = addDecimalAndUnits(item.weightPrice);
            item.averageWeight = item.averageWeight + massUnit[item.averageWeightUnit];
          }

          (item.discounts || []).forEach(function (discount) {
            discount.price = '-' + addDecimalAndUnits(discount.price);
          });

          shipmentCnt = shipmentCnt + item.count;
        });

        priceObj.totalPostage = addDecimalAndUnits(totalPostage);
        priceObj.shipment = shipmentCnt;
        priceObj.additionalServicesPrice = addDecimalAndUnits(additionalServicesPrice);
      } else {
        priceObj = null;
      }

      return priceObj;
    }

    function extractCalculatedPrice (priceObj) {
      priceObj = priceObj || angular.copy(Common.get('pricing', {}));

      return modifyPriceObj(priceObj);

    }

    function checkPostage (selectedProduct) {
      const userType = $rootScope.isNCPUser() ? 'company' : 'public';
      const deliveryUserType = selectedProduct.pricingInfo.deliveryOptions.userType;
      /* Some deliveryOptions have no userType */
      return !deliveryUserType || deliveryUserType === 'any' || deliveryUserType === userType;
    }

    function getRecipients () {
      let recipientsData = Common.get('recipients.validAddressCount', 0);
      const addressType = Common.get('recipients.addressType');
      const targetType = Common.get('recipients.targetType', 'INDIVIDUALS');
      // NOTE: include ODR for this condition for now.
      // TODO: have separate condition and getter for ODR when we get enough info
      if ((addressType === 'ADR' || addressType === 'ODR') && (targetType === 'INDIVIDUALS' || targetType === 'COMPANIES')) {
        recipientsData = Common.get('recipients.refinedAddressCount', 0);
      }

      return recipientsData;
    }

    function checkCompletion (terms) {
      let completed = true;
      const serviceType = Common.get('serviceType', false);
      const recipients = getRecipients();
      const productDelivery = Common.get('productDelivery', false);
      const materialDetails = Common.get('materialDetails', false);
      const sendoutName = Common.get('sendoutName', false);
      const correctUserTypePostage = Common.get('serviceType') === 'admail-odr' ? true : checkPostage(productDelivery);

      // TODO: also add check for customer number
      if (!serviceType || !recipients || !productDelivery || !materialDetails || !terms || !sendoutName
        || !correctUserTypePostage) {
        completed = false;
      }

      return completed;
    }

    function buildReferenceAddress (deliveryOption) {
      let referenceObj;
      const address = Common.get('referenceAddressInfo', null);
      const referenceSamples = deliveryOption.referenceSamples;

      if (address && referenceSamples) {
        referenceObj = {
          addressLine1: address.firstName + ' ' + address.lastName,
          street: address.address.street,
          city: address.address.city,
          zipcode: address.address.zipcode,
          country: Common.getServiceCountry(),
          referenceSamples: referenceSamples.copies

        };
      }

      return referenceObj;
    }

    function buildODRFilters (productDelivery) {
      const recipients = Common.get('recipients');
      if (recipients.addressType !== 'ODR') {
        return;
      }
      const materialDetails = Common.get('productDelivery.odrDetails.materialDetails');
      const odrDetails = Common.get('productDelivery.odrDetails');
      const dimensions = materialDetails;
      const highTraffic = Common.get('weekInfo').highTraffic;


      const zipcodes = Common.get('zipcodes', []).map(function (zipcode) { return zipcode.toString(); });//remap numbers to string
      const recipient = recipients.odrFilters[recipients.targetType].formOfHousing;
      const service = odrCalendarFactory.getService(
        productDelivery.pricingInfo.deliveryOptions.ODRService,
        productDelivery.deliveryDate);

      return {
        postalCodes: zipcodes,
        postalCodesGroup: [], // Can be left empty
        recipient: recipient.toLowerCase(),
        service: service,
        weight: productDelivery.paymentSolution === 'ODR' ? dimensions.weight : null,
        thickness: productDelivery.paymentSolution === 'ODR' ? dimensions.thickness : null,
        width: productDelivery.paymentSolution === 'ODR' ? dimensions.width : null,
        length: productDelivery.paymentSolution === 'ODR' ? dimensions.length : null,
        highTraffic: highTraffic,
        terminalType: productDelivery.paymentSolution === 'ODR' ? odrDetails.center : null,
        dropOffPoint: productDelivery.paymentSolution === 'ODR' ? odrDetails.terminal.unitId : null
      };
    }

    function getOdrDeliveryOption (product) {
      if (Common.get('recipients.addressType') === 'ODR') {
        return product.pricingInfo.deliveryOptions.targetType;
      }

      return;
    }

    function buildPlaceOrderParams () {
      const productDelivery = Common.get('productDelivery');
      const targetType = Common.get('recipients.targetType', 'FILE');
      const bisnodeFilters = (function () {
        switch (targetType) {
          case 'INDIVIDUALS': return Common.get('adrData');
          case 'COMPANIES': return companyFactory.constructRequest();
          default:
            break;
        }
      })();

      if (bisnodeFilters) { // undefined for FILE, ADR etc
        bisnodeFilters.zipcodes = recipientsFactory.transformZipcodes(Common.get('zipcodes', []).join(','));
      }

      const params = {
        addressesFolderId: Common.get('addressesFolderId'),
        originalAddressFileName: Common.get('originalAddressFileName'),
        addressType: Common.get('recipients.addressType'), //FIXME: need to set AddressType, (FILE, ADR, ODR)
        targetType,

        paymentMethod: 'CARD', // Default
        productId: productDelivery.productId,
        deliveryDate: productDelivery.deliveryDate,
        deliveryId: productDelivery.pricingInfo.deliveryOptions.id,
        prefacePage: Common.get('preface', false),
        name: Common.get('sendoutName'),
        material: Common.get('materialFolderId'),
        country: pnTopbar.market,
        language: pnTopbar.language,
        senderInfo: Common.get('senderInfo'),
        referenceAddress: buildReferenceAddress(productDelivery.pricingInfo.deliveryOptions),
        bisnodeFilters: bisnodeFilters,
        odrFilters: buildODRFilters(productDelivery),
        // this is for calculating correct price in lambda
        // returns INDIVIUALS OR COMPANIES
        odrDeliveryOption: getOdrDeliveryOption(productDelivery)
      };

      console.log(params);

      return params;
    }

    function buildContactInfo (form) {
      const params = Common.get('addressInfo', {});

      const countryNames = {
        SE: 'Sweden',
        DK: 'Denmark'
      };

      params.address.country = countryNames[pnTopbar.market];
      params.address.countryCode = pnTopbar.market;

      if (form === 'company') {
        delete params.firstName;
        delete params.lastName;
      } else {
        delete params.company;
      }

      if (!params.mobile || params.mobile.replace(/^\s+/, '').replace(/\s+$/, '') === '') {
        delete params.mobile;
      }

      return params;
    }

    factory.integrateWithSelected = integrateWithSelected;
    factory.removeOtherDeliveryOptions = removeOtherDeliveryOptions;
    factory.extractCalculatedPrice = extractCalculatedPrice;
    factory.getPaymentMethods = getPaymentMethods;
    factory.checkCompletion = checkCompletion;
    factory.addDecimalAndUnits = addDecimalAndUnits;
    factory.buildPlaceOrderParams = buildPlaceOrderParams;
    factory.buildContactInfo = buildContactInfo;
    factory.setPaymentResponseCode = setPaymentResponseCode;
    factory.getPaymentResponseCode = getPaymentResponseCode;
    factory.fetchProductTerms = fetchProductTerms;
    // factory.getPtmObjectId = getPtmObjectId;

    return factory;
  }

  angular.module('web2print.payment')
    .factory('paymentFactory', paymentFactory);
})();
